// @flow
import { SAVE_GROUP, SAVE_GROUP_PENDING, SAVE_GROUP_COMPLETE, SAVE_NEW_GROUP_COMPLETE } from './constants';

import { createAction } from 'redux-actions';

export const saveGroup = createAction(SAVE_GROUP);
export const saveGroupPending = createAction(SAVE_GROUP_PENDING);
export const saveGroupComplete = createAction(SAVE_GROUP_COMPLETE);
export const makeSaveNewGroupComplete = ({ name, consumers }: { name: string, consumers: Array<string> }) =>
    createAction(SAVE_NEW_GROUP_COMPLETE, ({ nodeId }) => ({ id: nodeId, name, consumers }));



// WEBPACK FOOTER //
// ./src/core/state/groups/actions.js